import { useEffect } from 'react';

import { replaceSlateEditorHtml, replaceSlateEditorText } from './transforms';

export const useMergeForcedTextValue = (editor, forcedTextValue) => {
  useEffect(() => {
    if (forcedTextValue == null || !editor) {
      return;
    }

    // if forcedTextValue starts with <p> and ends with </p> then it's html, otherwise it's plain text
    if (forcedTextValue.startsWith('<p>') && forcedTextValue.endsWith('</p>')) {
      replaceSlateEditorHtml(editor, forcedTextValue);
    } else {
      replaceSlateEditorText(editor, forcedTextValue);
    }
  }, [forcedTextValue, editor]);
};
